/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';
import {
  TeamFiltersFetchInstitutionsAction,
  TeamFiltersFetchInstitutionsSuccessAction,
  TeamFiltersSetSitesAction,
  TeamFiltersState,
  TeamFiltersToggleActiveFiltersAction,
  TeamFiltersToggleSelectedFiltersAction,
} from './teamFilters.types';
import { createSliceHook, makeActionCreator } from '../helpers';
import { RootState } from '../store';
import { userRoles } from '../../constants/rolesList';
import { toggleFilterState } from '../usersFilters/toggleFilterState';

const initialState: TeamFiltersState = {
  loading: false,
  error: undefined,
  selectedFilters: {
    institution: [],
    role: [],
    site: [],
  },
  allFilters: {
    institution: [],
    role: userRoles,
    site: [],
  },
  state: {
    institution: {
      active: false,
      label: 'Institution',
    },
    role: {
      active: false,
      label: 'Role',
    },
    site: {
      active: false,
      label: 'Site',
    },
  },
};

const { act, actReject, actReq, actResolve, actEmpty } =
  makeActionCreator<TeamFiltersState>();

export const teamFiltersSlice = createSlice({
  name: 'teamFilters',
  initialState,
  reducers: {
    toggleActiveFilters: (
      filterSliceState,
      action: TeamFiltersToggleActiveFiltersAction
    ) => toggleFilterState(filterSliceState, action.payload),
    toggleSelectedFilters: act<
      TeamFiltersToggleSelectedFiltersAction['payload']
    >(({ name, value }, { selectedFilters }) => ({
      selectedFilters: {
        ...selectedFilters,
        [name]: selectedFilters[name]?.includes(value) ? [] : [value],
      },
    })),
    fetchInstitutions: actReq<TeamFiltersFetchInstitutionsAction['payload']>(),
    fetchInstitutionsSuccess: act<
      TeamFiltersFetchInstitutionsSuccessAction['payload']
    >((ins, { allFilters }) => ({
      loading: false,
      allFilters: {
        ...allFilters,
        institution: ins ?? [],
      },
    })),
    fetchInstitutionsFailure: actReject(),
    setSites: act<TeamFiltersSetSitesAction['payload']>(
      (sites, { allFilters }) => ({
        allFilters: {
          ...allFilters,
          site: sites.map(site => ({
            value: site.code,
            label: site.code,
          })),
        },
      })
    ),
    reset: () => {
      return initialState;
    },
  },
});

export const { toggleActiveFilters, reset } = teamFiltersSlice.actions;

export const actions = {
  ...teamFiltersSlice.actions,
};

export const useTeamFiltersSlice = createSliceHook(
  teamFiltersSlice.name,
  actions
);

export const selectTeamFiltersState = (root: RootState) => root.teamFilters;
